import React, { FC, useEffect } from 'react'
import i18n from 'i18next'
import { IMenuItemProps } from '../Bill'
import { payMobx } from '@mobxStore'
import { apConfigG } from '@ctrls/third'

const MenuItem: FC<IMenuItemProps> = ({ onSelect }) => {
  useEffect(() => {
    const channelType = payMobx.methodChannelMap.alipay
    if (channelType === 'AlipayApp') {
      apConfigG.init()
    }
    return () => {
      apConfigG.remove()
    }
  }, [payMobx.methodChannelMap])
  return (
    <li className='group'>
      <div className='group-title' onClick={() => onSelect('alipay')}>
        <img src={require('@img/payment/alipay.png')} />
        {i18n.t('pay.alipay')}
      </div>
    </li>
  )
}

export default MenuItem
